<template>
  <div class="columns is-multiline">
    <div class="column is-12">
      <h3 class="title is-5">Tipo de cosumidor</h3>
    </div>
    <div class="column is-12">
      <option-select :options="segment" @select="onSelect"/>
    </div>
  </div>
</template>

<script>
const options = [
  {
    label: 'Cliente directo',
    value: 'Cliente directo'
  },
  {
    label: 'Consumidor final',
    value: 'Consumidor final',
  }
];
export default {
  name: "ConsumerType",
  computed: {
    segment() {
      return options;
    }
  },
  data() {
    return {
      type: ''
    }
  },
  methods: {
    onSelect(option) {
      this.$emit('done', {
        key: 'consumerType',
        customerType: option
      });
    }
  }
}
</script>

<style scoped>

</style>
